import { useState, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Box, useMediaQuery } from '@mui/material';
import MiniDrawer from '@/components/Drawer/Drawer';
import { Navbar } from '@/components/Navbar/Navbar';
import { useBannerStore } from '@/stores/bannerStore';
import { useAuthStore } from '@/stores/authStore';
import { AccountStatusTypes } from '@/helpers/accountStatus';
import PlansModal from '@/pages/Home/components/PlansModal/PlansModal';
import ExtensionHashTrigger from '@/components/ExtensionHashTrigger';
import { RouteMap } from '@/routes/Routes';
const PrivateLayout = () => {
  const isTabletOrBelow = useMediaQuery('(max-width:1100px)'); // Collapses on iPads; laptops and iPad Pro 12.9" stay expanded
  // Initialize drawer closed on tablets and below — expanded drawer crowds content on iPads
  const [isDrawerOpen, setDrawerOpen] = useState(!isTabletOrBelow);
  const { accountStatus } = useAuthStore();
  const { userLoggedIn, loading } = useAuthStore();

  const { headerHeight } = useBannerStore();
  const location = useLocation();
  const isOnboardingRoute = location.pathname.startsWith(RouteMap.ONBOARDING);

  // Update drawer state when screen size changes
  useEffect(() => {
    setDrawerOpen(!isTabletOrBelow);
  }, [isTabletOrBelow]);

  const isNotCheckoutPage = !location.pathname.startsWith(RouteMap.CHECKOUT);

  const toggleDrawer = () => {
    if (isOnboardingRoute) {
      return;
    }
    setDrawerOpen(!isDrawerOpen);
  };
  const drawerOpen = isOnboardingRoute ? false : isDrawerOpen;

  // Reserve drawer space during auth hydration to prevent layout shift.
  // Why: on routes like /shared/:token that don't use ProtectedRoute, PrivateLayout
  // mounts before Firebase resolves auth. Gating on userLoggedIn alone means the
  // drawer mounts late and pushes content right. Rendering while `loading` is true
  // keeps the 57–240px of space claimed from first paint.
  const showDrawer = userLoggedIn || loading;

  return (
    <>
      <Navbar />
      <Box display="flex">
        {showDrawer && <MiniDrawer isOpen={drawerOpen} toggleDrawer={toggleDrawer} />}
        <Box flexGrow="1" minWidth={0} overflow="auto" marginTop={`${headerHeight}px`}>
          <Outlet />
        </Box>
      </Box>
      <ExtensionHashTrigger />
      {accountStatus === AccountStatusTypes.EXPIRED && isNotCheckoutPage && <PlansModal />}
    </>
  );
};

export default PrivateLayout;
